// extracted by mini-css-extract-plugin
export default {"label":"Label_label__-xzfc","requiredSymbol":"Label_requiredSymbol__FlVOs","questionIcon":"Label_questionIcon__RPPVL"};